<template>
  <div class="i-jca-steps">
    <div class="description">
      <div class="header">How Does It Work?</div>
      <div class="sub">
        From start to finish, our tools and expert coaches guide you every step of the way through your job search so
        you stop guessing and start making real progress towards your goals.
      </div>
    </div>
    <div class="card">
      <img
        v-if="isLgOrLarger"
        class="curvy"
        :src="imageLine"
      />
      <template
        v-for="step in STEPS"
        :key="step.icon"
      >
        <div class="step">
          <img :src="step.icon" />
          <div class="bottom">
            <div class="main">{{ step.title }}</div>
            {{ step.text }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { breakpointLg } from "@/styles/variables"

import useIsScreenSize from "@/composables/useIsScreenSize"

// ASSETS
import imageLine from "@/assets/curly-dotted-line.svg"
import iconOne from "@/assets/icons/icon-gc-one.svg"
import iconTwo from "@/assets/icons/icon-gc-two.svg"
import iconThree from "@/assets/icons/icon-gc-three.svg"

// COMPOSABLES
const isLgOrLarger = useIsScreenSize(breakpointLg)

// CONSTANTS
const STEPS = [
  {
    icon: iconOne,
    title: "Career Report",
    text: "Pinpoint your best-fit roles, industries, and income potential"
  },
  {
    icon: iconTwo,
    title: "1:1 Career Coaching",
    text: "Join a community of job seekers and learn the strategies that help people land roles faster."
  },
  {
    icon: iconThree,
    title: "On-Going Support",
    text: "Get support with resumes, interview prep, and get help staying on track."
  }
]
</script>

<style scoped lang="scss">
.i-jca-steps {
  @include flex(column, start, stretch, $gap: 30px);

  width: 100%;

  .description {
    @include flex(column, start, center, $gap: 18px);

    text-align: center;

    .header {
      @include display-sm;

      font-weight: 700;
    }

    .sub {
      @include text-lg;

      max-width: 700px;
      color: $black700;
    }
  }

  .card {
    @include flex(row, center, stretch, wrap, 45px);
    @include border-radius-md;

    background: linear-gradient(180deg, #fff 0%, #eae7ff 100%);
    border: 1px solid $zumthor100;
    padding: 35px 20px;
    text-align: center;
    position: relative;

    @media screen and (min-width: $breakpoint-md) {
      gap: 20px;
    }

    @media screen and (min-width: $breakpoint-lg) {
      @include grid($cols: repeat(3, 1fr), $rows: auto, $align-items: stretch, $gap: 20px);

      justify-items: center;
    }

    .curvy {
      position: absolute;
      max-width: 530px;

      @media screen and (min-width: $breakpoint-xl) {
        max-width: unset;
      }
    }

    .step {
      @include flex(column, start, center, $gap: 25px);
      @include text-sm;

      max-width: 314px;
      color: $black500;

      .bottom {
        @include flex(column, start, center, $gap: 10px);

        .main {
          @include text-md;

          color: $black900;
          font-weight: 700;
        }
      }
    }
  }
}
</style>
